module.exports = __webpack_public_path__ + "static/media/UV-ML.085be412.jpg";